module.exports = __webpack_public_path__ + "img/consVerificacao.fdf4c230.jpg";